module.exports = {
  "defaultApiVersion": "2021-10-21",
  "api": {},
  "project": {}
}



//////////////////
// WEBPACK FOOTER
// ./config/@sanity/vision.json?sanityPart=config%3A%40sanity%2Fvision
// module id = 3204
// module chunks = 0